module.exports = __webpack_public_path__ + "static/media/map_png.6d7c21fe.png";